( function () {
	'use strict';

	function evidenceCounter ( ) {
		return {
			'templateUrl'  : '/templates/components/evidences/counter/evidence-counter.html',
			'restrict'     : 'E',
			'controller'   : 'EvidenceCounter',
			'controllerAs' : 'vm',
			'scope'        : {
				'model'           : '=',
				'index'           : '=',
				'count'           : '=',
				'counterEvidence' : '='
			}
		};
	}

	angular
		.module( 'app.templates' )
		.directive( 'evidenceCounter', evidenceCounter );
} )( );
